import { Button, Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress } from '@mui/material';
import { Box } from '@mui/system';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeDialog } from '../../../../features/dialog';
import { enqueueErrorSnack, enqueueSuccessSnack } from '../../../../features/snackbar';
import { editSubscriber } from '../../../../features/subscriber';
import SubscriberForm from '../SubscriberForm';
import { hasErrors } from '../../../../common';

const DIALOG_ID = "editSubscriber"
const DIALOG_WIDTH = "sm"

function EditSubscriberDialog() {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const subscribers = useSelector(state => state.subscriber.list);
    const project = useSelector(state => state.project.single);
    const subscriberId = useSelector((state) => state.dialog[DIALOG_ID])
    const show = !!subscriberId;
    const subscriber = subscriberId ? subscribers.find(j => j.id === subscriberId) : null;
    const [errors] = useState({});
    const [form, setForm] = useState({});

    const save = e => {
        e && e.preventDefault() && e.stopPropagation();
        const errors = {}
        if(hasErrors(errors)){
            return;
        }

        setLoading(true);
        dispatch(editSubscriber({subscriber: form, project}))
        .then(r => {
            dispatch(closeDialog(DIALOG_ID));
            dispatch(enqueueSuccessSnack("Subscriber saved"))    
        })
        .catch(e => {
            dispatch(enqueueErrorSnack("Error: " + e))    
        })
        .finally(() => {
            setLoading(false);
        })
    }

    const onClose = () => {
        dispatch(closeDialog(DIALOG_ID));
    }
    

    useEffect(() => {
        setForm(subscriber);
    }, [subscriber, subscriberId]);

    return <Dialog
        open={!!show}
        onClose={onClose}
        fullWidth
        maxWidth={DIALOG_WIDTH}
        
    >
        <form onSubmit={save}>
            <DialogTitle>
                Edit subscriber
            </DialogTitle>
            <DialogContent dividers={false}>
                <Box pr={3}>
                    <SubscriberForm form={form || subscriber || {}} onChange={setForm} errors={errors} />
                </Box>
            </DialogContent>
            <DialogActions>
                {loading && <LinearProgress />}
                {!loading && <Box sx={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}>
                    <Button sx={{marginRight: 2}} onClick={onClose} >Cancel</Button>
                    <Button variant="contained" color="secondary" type="submit">Save Subscriber</Button>
                </Box>}
            </DialogActions>
        </form>
    </Dialog>
}

export default EditSubscriberDialog;